import { BlockParameters, PipelinePhase } from '@visualizer/types';
import { PipelineBlock } from '../PipelineBlock';
import ShadowFilterStage, { ShadowFilterStageParameters } from '../stages/filters/ShadowStage';
import { AddMetadata, BlockKeys } from '../BlockCatalog';

export interface ShadowBlockParameters extends BlockParameters, ShadowFilterStageParameters {}

@AddMetadata({
    type: BlockKeys.Shadow,
    name: 'Shadow',
    description: 'Filter sensors in Layer direction (or inverted)',
    visible: false,
    pipelinePhase: PipelinePhase.Post,
})
class ShadowBlock extends PipelineBlock<ShadowBlockParameters> {
    constructor(params: ShadowBlockParameters, stringId?: string) {
        super(params, stringId);
    }

    protected override serializeParams(): ShadowBlockParameters {
        return {
            enabled: false,
            polygons: [],
            isInverted: this.getParams().isInverted,
            raycastMeshes: [],
            globalBox: undefined,
        };
    }

    protected override defineStages() {
        return [
            new ShadowFilterStage({
                polygons: this.getParams().polygons,
                isInverted: this.getParams().isInverted,
                raycastMeshes: this.getParams().raycastMeshes,
                globalBox: this.getParams().globalBox,
            }),
        ];
    }
}

export default ShadowBlock;
